import { z } from 'zod';

export const VehicleSchema = z.object({
  id: z.string(),
  fullFrontendId: z.string(),
});

export const VehiclePreviewSchema = VehicleSchema.pick({
  id: true,
  fullFrontendId: true,
});

export type Vehicle = z.infer<typeof VehicleSchema>;
export type VehiclePreview = z.infer<typeof VehiclePreviewSchema>;
